import { Form, Field } from "formik";
import {
  Button,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { BiRupee } from "react-icons/bi";
import styles from "./Position.module.scss";
import DatePicker from "../common/Form/DatePicker";
import FileInputField from "../common/Form/FileInput";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import { useEffect, useState } from "react";
import MultiSelect from "../common/Form/Multiselect";
import Loader from "../common/Loader/Loader";
import { AiOutlineDownload } from "react-icons/ai";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats, undoChange, redoChange } from "../../components/common/CustomEditor";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";

const MultiSelectReact =({  
  field,
  form,
  options,
  isMulti = false,
  disabled,
  placeholder = "Select"}) => {
    const [query, setQuery] = useState("");

  function onChange(option) {
    form.setFieldValue(
      field.name,
      option ? option.map((item) => item.value) : []
    );
  }


  const getValue = () => {
    if (options && field?.value) {
     let  valuesArray 
     if(Array.isArray(field.value)){
      valuesArray = field.value
     }else{
     const dataArr = field?.value?.split(',')
      valuesArray = dataArr.map((ele)=> parseInt(ele))
     }
      return options.filter((ele)=> valuesArray.includes(ele.value))
    } else {field
      return isMulti ? [] : "";
    }
  };

    return (
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        name={field.name}
        value={getValue()}
        onChange={onChange}
        onInputChange={(value) => setQuery(value)}
        options={options?.filter(x => x.label.toLowerCase()?.includes(query?.toLowerCase()))?.slice(0, 5)}
        isMulti={true}
        isDisabled={disabled}
        placeholder={placeholder}
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#CBD9EA" : "transparent",
            borderRadius:'0.3rem' ,
            color: "black"
        }),
        menu: provided => ({ ...provided, width:"100%" ,right:'0px', borderRadius:'0.5rem' }),
        }}
      />
    );

}

const PositionForm = (props) => {
  const [options, setOptions] = useState([]);
  // const [clusetrOption, setClusterOption] = useState([]);
  const [citiesOption, setCitiesOption] = useState([]);
  const [selectedOp, setSelectedOp] = useState([]);
  const [selectedArr, setSelectedArr] = useState([]);
  const { setFieldValue, getFieldProps, values } = useFormikContext();
  const { errors, touched } = props;
  const jobProfiles = useSelector((state) => state.jobProfiles.masterData);
  // const assignee = useSelector((state) => state.jobProfiles.assignee);
  const cluster = useSelector((state) => state.jobProfiles.cluster);
  const citiesData = useSelector((state) => state.jobProfiles.citiesData);
  const assignee = useSelector((state) => state.jobProfiles.inetviewer);

  useEffect(() => {
    if (props?.editedData && props?.editedData?.dueDate) {
      setFieldValue("dueDate", new Date(props?.editedData?.dueDate))
    }
  }, [props?.editedData])

  useEffect(() => {
    if (props?.editedData && props?.editedData?.jobTitle) {
      setFieldValue("jobTitle", props?.editedData?.jobTitle)
    }
  }, [props?.editedData])

  useEffect(() => {
    let merger = [];
    if (props?.editedData?.assigneeId && props?.editedData?.assigneeId !== "") {
      const [value, label] = [
        props?.editedData?.assigneeId?.split(","),
        props?.editedData?.assigneeNames?.split(","),
      ];
      merger = value?.map((node, index) => ({
        value: node,
        label: `${label[index]}`,
      }));
    }
    if (assignee?.length > 0) {
      const resVal = assignee?.map((val) => {
        return {
          value: val?.id,
          label: val?.name,
        };
      });
      let finalArr = resVal;
      if (merger && merger.length > 0) {
        finalArr.concat(merger);
      }
      setOptions([
        ...new Map(finalArr.map((item) => [item["value"], item])).values(),
      ]);
    } else {
      setOptions(merger);
    }
  }, [assignee]);
  const getFiled = getFieldProps();
  useEffect(() => {
    if (options && options.length > 0) {
      let fOpArr = [];

      options.forEach((val) => {

        // if (getFiled.value && getFiled?.value?.assigneeId?.includes(val?.value)) {
        //   fOpArr.push(val);
        // }
      });
      setSelectedOp([...selectedOp, ...fOpArr]);
    }
  }, [getFiled.value]);

  useEffect(() => {
    if (selectedOp && selectedOp.length > 0) {
      setOptions([
        ...new Map(
          [...selectedOp, ...options].map((item) => [item["value"], item])
        ).values(),
      ]);
      let selArr = [];
      selectedOp?.forEach((val) => {
        selArr.push(Number(val?.value));
      });
      setSelectedArr(selArr);
    }
  }, [selectedOp]);

  const hasWhiteSpace = (val) => {
    const strippedHtml = val.replace(/<[^>]+>/g, '');
    return strippedHtml.trim().length > 0 ? true : false ; 
  }
    
  // const handleKeyPress = (event) => {
  //   console.log("🚀 ~ file: AddPositionForm.js:170 ~ handleKeyPress ~ event:", event)
  //   const text = event.target.innerText.trim();
  //   if (text === "") {
  //   event.preventDefault(); // prevent typing white spaces
  //   }
  // };

  // useEffect(() => {
  //   if (cluster && cluster.length > 0) {
  //     const resVal = cluster.map((val) => {
  //       return {
  //         value: val?.id,
  //         label: val?.name,
  //       };
  //     });
  //     resVal.unshift({ value: "", label: "Select Cluster" });
  //     setClusterOption(resVal);
  //   }
  // }, [cluster]);

  useEffect(() => {
    if (citiesData && citiesData.length > 0) {
      const resVal = citiesData.map((val) => {
        return {
          value: val,
          label: val,
        };
      });
      resVal.unshift({ value: "Remote", label: "Remote" })
      setCitiesOption(resVal);
    }
  }, [citiesData]);

  const ProfileChange = (e) => {
    if (e.target.value) {
      const findJob =
        jobProfiles &&
        jobProfiles.find((itm) => Number(itm.id) === Number(e.target.value));
      setFieldValue("jobProfile", e.target.value);
      if (findJob) {
        if (findJob?.min_salary && findJob?.min_salary != null) {
          setFieldValue("budgetFrom", Number(findJob?.min_salary));
        } else {
          setFieldValue("budgetFrom", "");
        }
        if (findJob?.max_salary && findJob?.max_salary != null) {
          setFieldValue("budgetTo", Number(findJob?.max_salary));
        } else {
          setFieldValue("budgetTo", "");
        }
      }
    }
  };
  
  return (
    <Form className={`${styles.positionForm}`} encType="multipart/form-data">
      <Row>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Job Title</Label>
            <Field
              className="form-control"
              maxlength="30"
              // onInputChange={props?.editedData?.jobTitle}
              name="jobTitle"
              autocomplete="off"
              placeholder="Enter Job Title"
              disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
            />
            {errors.jobTitle && touched.jobTitle ? (
              <div className={styles.formError}>{errors.jobTitle}</div>
            ) : null}
          </FormGroup>
        </Col>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Job Profile</Label>
            <Field
              className="form-control"
              as="select"
              onChange={(e) => {
                ProfileChange(e);
              }}
              name="jobProfile"
              autocomplete="off"
              disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
            >
              <option value="" selected disabled>
                Select Profile
              </option>
              {jobProfiles &&
                jobProfiles.length > 0 &&
                jobProfiles.map((val, index) => {
                  return <option value={val.id}>{val.name}</option>;
                })}
            </Field>
            {errors.jobProfile && touched.jobProfile ? (
              <div className={styles.formError}>{errors.jobProfile}</div>
            ) : null}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Position Type</Label>
            <Field className="form-control" as="select" name="positionType" disabled={props?.editedData?.jobStatus === "Closed" ? true : false}>
              <option value="Full Time">Full Time</option>
              <option value="Part Time">Part Time</option>
              <option value="Intern">Intern</option>
              <option value="Contractual">Contractual</option>
            </Field>
          </FormGroup>
        </Col>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Assignee</Label>
            <Field
              name="assigneeId"
              id="assigneeId"
              placeholder="Select Assignee"
              isMulti={true}
              component={MultiSelectReact}
              options={options}
              selectedArr={selectedArr}
              disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
            />
          </FormGroup>
          {/* <FormGroup className="form-group">
            <Label className={styles.formLabel}>Cluster</Label>
            <Field
              name="clusterId"
              id="clusterId"
              placeholder="Select Cluster"
              isMulti={false}
              component={MultiSelect}
              options={clusetrOption}
              autocomplete="off"
            />
          </FormGroup> */}
        </Col>
      </Row>

      {/* <FormGroup className="form-group">
        <Label className={styles.formLabel}>Job Description</Label>
        <FileInputField name="descriptionFile" />
        {props?.editedData &&
          props?.editedData?.descriptionFile &&
          getFiled?.value?.descriptionFile === "" ? (
          <div className={styles.fileDisplay}>
            {" "}
            {props?.editedData?.descriptionFile.split("/").pop()}{" "}
            <a
              href={props?.editedData?.descriptionFile}
              download={props?.editedData?.descriptionFile.split("/").pop()}
              target="_blank"
            >
              <AiOutlineDownload className={styles.downloadPart} />
            </a>
          </div>
        ) : (
          ""
        )}
        {errors.descriptionFile && touched.descriptionFile ? (
          <div className={styles.formError}>{errors.descriptionFile}</div>
        ) : null}
      </FormGroup> */}

      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Experience</Label>
        <Row>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Year</Label> */}
            <Field
              className="form-control"
              onKeyPress={(event) => {
                OnlyNumberLength(event);
              }}
              maxlength="2"
              name="experienceYear"
              placeholder="Year"
              autocomplete="off"
              disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
            />
          </Col>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Month</Label> */}
            <Field className="form-control" name="experienceMonth" as="select" disabled={props?.editedData?.jobStatus === "Closed" ? true : false}>
              <option value="" className="disableOption" selected disabled>Month</option>
              {Array.from(Array(12), (e, i) => {
                return <option value={i}>{i}</option>;
              })}
            </Field>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Annual Budget</Label>
        <Row>
          <Col md={6}>
            <InputGroup>
              <InputGroupText>
                <BiRupee />{" "}
              </InputGroupText>
              <Field
                className="form-control"
                onKeyPress={(event) => {
                  OnlyNumberLength(event);
                }}
                maxlength="8"
                placeholder="From"
                name="budgetFrom"
                value={props?.editedData?.jobStatus === "Closed" ?getFiled?.value?.budgetFrom.toLocaleString('en-IN', {currency: 'INR' }):getFiled?.value?.budgetFrom}
                autocomplete="off"
                disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
              />
            </InputGroup>
          </Col>
          <Col md={6}>
            <InputGroup>
              <InputGroupText>
                <BiRupee />{" "}
              </InputGroupText>
              <Field
                className="form-control"
                onKeyPress={(event) => {
                  OnlyNumberLength(event);
                }}
                maxlength="8"
                placeholder="To"
                name="budgetTo"
                value={props?.editedData?.jobStatus === "Closed" ?getFiled?.value?.budgetTo.toLocaleString('en-IN', {currency: 'INR' }):getFiled?.value?.budgetTo}
                autocomplete="off"
                disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
              />
            </InputGroup>
          </Col>
        </Row>
      </FormGroup>
      <Row>
        <Col xs="12" md="6">
          <FormGroup className="form-group dueDateFormGroup">
            <Label className={styles.formLabel}>Due Date</Label>
            <DatePicker
              className="form-control"
              name="dueDate"
              autoComplete="off"
              // maxDate={new Date()}
              disabled={props?.editedData?.jobStatus === "Closed"? true : false}
            />
          </FormGroup>
        </Col>
        <Col xs="12" md="6">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Priority</Label>
            <Field className="form-control" as="select" name="priority" disabled={props?.editedData?.jobStatus === "Closed" ? true : false}>
              <option value="Normal">Normal</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </Field>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" md="6">
          <FormGroup className="form-group" >
            <Label className={styles.formLabel}>Location</Label>
            {citiesOption && citiesOption.length > 0 ? (
              <Field
                name="location"
                id="location"
                placeholder="Select Location"
                isMulti={false}
                component={MultiSelect}
                options={citiesOption}
                autocomplete="off"
                disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
              />
            ) : (
              <Field className="form-control" name="location" type="text" />
            )}
            {errors.location && touched.location ? (
              <div className={styles.formError}>{errors.location}</div>
            ) : null}
          </FormGroup>
        </Col>
      <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>No. of Openings</Label>
            <Field
              className="form-control"
              onKeyPress={(event) => {
                OnlyNumberLength(event);
              }}
              maxlength="2"
              name="noOfProfiles"
              autocomplete="off"
              disabled={props?.editedData?.jobStatus === "Closed" ? true : false}
            />
            {errors.noOfProfiles && touched.noOfProfiles ? (
              <div className={styles.formError}>{errors.noOfProfiles}</div>
            ) : null}
          </FormGroup>
        </Col>
        </Row>
      <Row>
      <Col xs="12" md="6">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Job Type</Label>
            <Field className="form-control" as="select" name="jobType" disabled={props?.editedData?.jobStatus === "Closed" ? true : false}>
              <option value="internal">Internal</option>
              <option value="external" selected>External</option>
            </Field>
          </FormGroup>
        </Col>
      </Row>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Job Description</Label>
        <div className="discription-editor">
          <EditorToolbar className="description" />
          <ReactQuill
            theme="snow"
            name="description"
            id="description"
            value={values?.description}
            onChange={(val) => { 
                if(hasWhiteSpace(val)){
                 setFieldValue("description", val)
                }else{
                  setFieldValue("description","")
                }
            }}
            placeholder={"Please describe job opening"}
            modules={{
              toolbar: {
                container: ".description",
                handlers: {
                  undo: undoChange,
                  redo: redoChange
                }
              },
              history: {
                delay: 500,
                maxStack: 100,
                userOnly: true
              }
            }}
            formats={formats}
            readOnly={props?.editedData?.jobStatus === "Closed" ? true : false}
          />
        </div>
        {errors.description && touched.description ? (
          <div className={styles.formError}>{errors.description}</div>
        ) : null}
      </FormGroup>
    
      {props?.editedData?.jobStatus === "Drafted" ? 
      <Button
          type="submit"
          disabled={props?.submited}
          className={styles.brandButton}
          onClick={() => setFieldValue('jobStatus', "Active")}
        >
          {props?.submited && props.btnUpdate !== 'update' &&<Loader height={30} width={30} color={"#FFFFFF"} />}
          {props?.editedData?.jobStatus === 'Drafted' ? "Publish" : ""}
        </Button> : ''}

    {props?.editedData?.jobStatus === "Active" ? 
      <Button
          type="submit"
          disabled={props?.submited}
          className={styles.brandButton}
          onClick={() => setFieldValue('jobStatus', "Closed" )}
        >
          {props?.submited && <Loader height={30} width={30} color={"#FFFFFF"} />}
          {props?.editedData?.jobStatus === 'Active' ? "Close this Opening" : ""}
        </Button> : ''}

      {props?.editedData != null && props?.editedData?.jobStatus === "Drafted" || props?.editedData?.jobStatus === 'Active' ?  
        <Button
          type="submit"
          disabled={props?.submited}
          className={styles.brandButton}
          onClick={()=>props.setBtnUpdate('update')}
        >
          {(props?.submited && props.btnUpdate === 'update') && <Loader height={30} width={30} color={"#FFFFFF"} />}
          Update
        </Button> :
        !props?.editedData?.jobStatus?

        <Button
        type="submit"
        disabled={props?.submited}
        className={styles.brandButton}
      >
        { props?.submited && <Loader height={30} width={30} color={"#FFFFFF"} />}
        Save
      </Button>
      :''
        }
    </Form>
  );
};

export default PositionForm;
